var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"np-fade"}},[(
			_vm.hasDefaultSlot ||
				_vm.error ||
				(_vm.rule && _vm.$validator.errors.firstByRule(_vm.name, _vm.rule)) ||
				(!_vm.rule && _vm.$validator.errors.has(_vm.name))
		)?_c('div',{staticClass:"text-red-600 text-sm"},[_vm._t("default",function(){return [(_vm.error)?[_vm._v(" "+_vm._s(_vm.error)+" ")]:(_vm.rule)?[_vm._v(" "+_vm._s(_vm.$validator.errors.firstByRule(_vm.name, _vm.rule))+" ")]:[_vm._v(" "+_vm._s(_vm.$validator.errors.first(_vm.name))+" ")]]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }